import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons/faCaretDown';
import { faCaretUp } from '@fortawesome/pro-solid-svg-icons/faCaretUp';
import React, { useState, useRef, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { Button } from 'ui-components/components/button';
import { FloatTextArea } from 'ui-components/components/float-text-area';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';
import { messages } from '../messages';
import style from './style.module.less';

export const PasteAddress = ({ placeholder = '', pasteAddressRequest, showChevron = false }) => {
  const [showPasteInput, setShowPasteInput] = useState(false);
  const [pasteAddressValue, setPasteAddressValue] = useState('');
  const intl = useIntl();
  const floatTextAreaRef = useRef();
  const togglePaste = useCallback(() => setShowPasteInput((show) => !show), []);

  const handlePasteChange = (value) => {
    setPasteAddressValue(value);
    pasteAddressRequest(value);
  };

  useEffect(() => {
    if (showPasteInput && floatTextAreaRef.current) {
      floatTextAreaRef.current.focus();
    }
  }, [showPasteInput, floatTextAreaRef]);

  const renderButton = () => {
    if (showChevron) {
      return (
        <Button className={style['paste-input-toggle-small']} onClick={togglePaste} theme={THEME_CONSTANTS.unstyled}>
          <span>{placeholder}</span>
          <div className={style['paste-input-toggle-icon']}>
            {showPasteInput ? <FontAwesomeIcon icon={faCaretUp} /> : <FontAwesomeIcon icon={faCaretDown} />}
          </div>
        </Button>
      );
    }
    return (
      <div className={style['paste-input-toggle']}>
        <Button onClick={togglePaste} theme='link'>
          {placeholder}
        </Button>
      </div>
    );
  };

  return (
    <>
      {renderButton()}
      {showPasteInput && (
        <div className={style['paste-address-field']}>
          <FloatTextArea
            ref={floatTextAreaRef}
            className={style['paste-address-entry']}
            id='paste-address-text-area'
            label={intl.formatMessage(messages.pasteAddressPlaceholder)}
            onChange={handlePasteChange}
            value={pasteAddressValue}
          />
        </div>
      )}
    </>
  );
};

PasteAddress.propTypes = {
  placeholder: PropTypes.string,
  pasteAddressRequest: PropTypes.func.isRequired,
  showChevron: PropTypes.bool,
};
